import { Component, EventEmitter, Input, OnInit, Output,ViewChildren,QueryList,ViewChild  } from '@angular/core';
import { URLS } from '../../../../environments/environment';
import { MessageService } from 'primeng/api';
import { Observable } from 'rxjs';
import { OrdersService } from '../../../dashboard/orders/orders.service';
import { map } from 'rxjs/operators';
import { FileUpload } from 'primeng/fileupload';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-order-documents-upload',
  templateUrl: './order-documents-upload.component.html',
  styleUrls: ['./order-documents-upload.component.scss'],
  providers: [MessageService],
})
export class OrderDocumentsUploadComponent implements OnInit {
  @Input() clearance: any;
  @Input() fileTypes: any[];
  @Input() orderID: number;
  uploadUrl = URLS.API + 'files/uploadByUser';
  @Output() onFileUpload: EventEmitter<any> = new EventEmitter<any>();
  userFile: string;
  orderFiles$: Observable<any[]>;
  orderFiles: any[];
  isDragging: boolean = false;
  isDraggingCategory: string | null = null;

  @ViewChildren('fileUploader') fileUploaders!: QueryList<any>;
  private currentFileUploaders: { [key: number]: any } = {};
  @ViewChild('fileUploader') fileUploader!: FileUpload;

 
  constructor(
    private messageService: MessageService,
    private orderService: OrdersService,
    private translate: TranslateService
  ) {}

  /** Display-only label for a file type: English mapping when UI is English, live DB label otherwise. */
  public docTypeLabel(ft: any): string {
    if (!ft) { return ''; }
    if (this.translate.currentLang !== 'en') { return ft.label; }
    const key = 'DOC_TYPE.' + ft.name;
    const en = this.translate.instant(key);
    return en && en !== key ? en : ft.label;
  }

  ngOnInit(): void {
    this.orderFiles$ = this.orderService.getOrderFiles(this.orderID).pipe(
      map((res: any) => {
        this.orderFiles = [...res.data];
        // this.fileTypes = this.fileTypes.filter(ft => !this.orderFiles.find(t => t.type === ft.name && t.status === 1));
        this.updateFileTypes();
        return res.data;
      })
    );
  }

  onFileSelected(event: any) {

  

    const firstFile = event.files[0];

    const testFormData = new FormData();
    this.beforeUpload({ formData: testFormData } as any, firstFile.name, firstFile.type);

    setTimeout(() => {
      this.fileUploader.upload();
    }, 100);
  }

  beforeUpload($event: { formData: FormData }, name: string, type: number) {
   
    $event.formData.append('orderID', this.orderID.toString());
    $event.formData.append('type', name);
    $event.formData.append('fileType', type.toString());

  }

  uploadSuccess($event) {
    if ($event.originalEvent.status === 200) {
      this.onFileUpload.emit($event.originalEvent.body);
      this.messageService.add({
        severity: 'success',
        summary: this.translate.instant('DOCUMENTS.UPLOAD_FILE'),
        detail: this.translate.instant('DOCUMENTS.FILE_UPLOADED_SUCCESS'),
      });
      this.orderFiles = $event.originalEvent.body.data;
      this.updateFileTypes();
    }

  }

  beforeCustomUpload($event: { formData: FormData }, file: any) {
    $event.formData.append('fieldname', 'custom');
    $event.formData.append('orderID', this.orderID.toString());
    $event.formData.append('type', this.userFile);
    $event.formData.append('fileType', file.id.toString());
  }
  updateFileTypes() {
    this.fileTypes = this.fileTypes.map((fileType) => {
      let found = this.orderFiles.find((of) => of.type === fileType.name);
      if (found) {
        fileType.STATUS = found.status;
      } else {
        fileType.STATUS = 0;
      }
      return fileType;
    });
  }

  onDragOver(event: DragEvent, categoryName: string) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = true;
    this.isDraggingCategory = categoryName;
    if (this.isDragging = true){
      this.isDraggingCategory == null;
    }
     

    

  }

  onDragLeave(event: DragEvent, categoryName: string) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;
    this.isDraggingCategory = null;
    

  }

  onDrop(event: DragEvent, panel: any, file?: any) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;
    this.isDraggingCategory = null;

    if (!event.dataTransfer?.files.length) return;

    const filesArray: File[] = Array.from(event.dataTransfer.files);
    
    if (panel && !panel.expanded) {
      panel.open();
    }

    setTimeout(() => {
      const uploaders = this.fileUploaders.toArray();
      const targetUploader = uploaders.find(uploader => uploader.name === file.name);
      
      if (targetUploader) {
        filesArray.forEach(singleFile => {
          const formData = new FormData();
          
          if (file) {
            this.beforeUpload({ formData } as any, file.name, file.id);
          } else {
            this.beforeCustomUpload({ formData } as any, { id: 0 });
          }

          targetUploader.files = [singleFile];
          targetUploader.upload();
        });
      } else {
        console.error('לא נמצא fileUploader מתאים');
      }
    }, 100);
}
}
